import {Settings, Selectors, PluginNames} from "../Settings";
import AjaxUtility from "../../../../../../ig_template/Resources/Public/Src/Js/Utility/AjaxUtility";

export default class Promotool {
	constructor(container) {
		this.ajaxTypeNum = Settings.AJAX_TYPE_NUM;

		this.container = container;
		this.promoForm = container.querySelector(Selectors.PROMOTOOL_FORM);
		this.sections = container.querySelectorAll(Selectors.SECTION);
		this.prizeSelectionButtons = container.querySelectorAll(Selectors.PRIZE);
		this.continueButtons = container.querySelectorAll('[data-changetosection]');

		this.propElements = Object.entries(container.querySelectorAll('[data-prop]'));

		this.bindHandlers();
		this.initialiseComponentState();
	}

	initialiseComponentState() {
		this.data = {};

		const formData = this.getFormData();

		this.setData({
			loading: false,
			formData: formData,
			currentSection: 0,
			prizename: '',
			prizeprice: 0
		});

		// skip first section (tool settings) if fields are already filled
		if(this.getCurrentSection() && this.validateSection0()) {
			this.changeToSection(1);
		}
	}

	getFormData(fullIdentifier = false) {
		return $(this.promoForm).serializeArray().reduce((carry, formValue) => {
			const identifiers = formValue.name.match(/\[(.*?)]/g);
			if ((fullIdentifier || identifiers[0] === "[log]") && formValue.value) {
				const key = fullIdentifier ? formValue.name.replace(/\[]]$/, '][]') : identifiers[1].replace(/[\[\]]/g, ''),
					value = formValue.value;

				if (formValue.name.match(/\[]/)) {
					// formValue is array
					if (!carry.hasOwnProperty(key)) {
						carry[key] = [];
					}
					carry[key].push(value);
					return carry;
				}

				carry[key] = value;
				return carry;
			}

			return carry;
		}, {});
	}

	bindHandlers() {
		if(this.promoForm) {
			this.promoForm.addEventListener('submit', e => this.submitPromoform(e));
		}

		for (const button of this.prizeSelectionButtons) {
			button.addEventListener('click', () => this.selectPrize(button));
		}

		for (const button of this.continueButtons) {
			button.addEventListener('click', () => this.changeToSection(parseInt(button.dataset.changetosection)));
		}
	}

	selectPrize(button) {
		if (this.data.prizeprice === 0) {
			button.classList.add('flipped');
			const input = button.querySelector('input');
			input.checked = true;

			this.setData({
				prizename: input.dataset.name,
				prizeprice: input.dataset.price
			});

			window.setTimeout(() => {
				this.toNextSection();
			}, 3500);
		}
	}

	changeToSection(i) {
		if (typeof this['validateSection' + this.data.currentSection] === 'function') {
			if(!this['validateSection' + this.data.currentSection]()) {
				// validation failed
				return;
			}
		}

		this.setData({
			currentSection: i,
			formData: this.getFormData()
		});
	}

	toNextSection() {
		this.changeToSection(this.data.currentSection + 1);
	}

	validateSection0() {
		return this.validateAllFieldsInSectionFilled(this.getCurrentSection());
	}

	validateAllFieldsInSectionFilled(section) {
		const inputs = [...section.querySelectorAll('input,select')];
		return inputs.find(input => (parseInt(input.value) === 0 || input.value === '')) === undefined;
	}

	submitPromoform(e) {

	}

	/**
	 * Set component data and update linked displays
	 * all updates to the internal store (data property) should be handled through this method
	 * @param data
	 */
	setData(data) {
		this.data = Object.assign(this.data, data);
		this.updateData();

		if (data.hasOwnProperty('currentSection')) {
			for (let i = 0; i < this.sections.length; i++) {
				if (i === data.currentSection) {
					this.sections[i].classList.add('current');
				} else {
					this.sections[i].classList.remove('current')
				}
			}
		}
	}

	/**
	 * Set component data in linked html elements
	 * automatically updates relevant data in DOM
	 */
	updateData() {
		for (const [key, element] of this.propElements) {
			element.innerText = this.data[element.dataset.prop];
		}
	}

	getCurrentSection() {
		return this.sections[this.data.currentSection];
	}
}
